// extracted by mini-css-extract-plugin
export default {"postname":"PostName_postname__fqFzW","photo":"PostName_photo__WnYSk","image":"PostName_image__HYx2Q"};